module.exports = __webpack_public_path__ + "img/Onepacklogo.a139d61f.png";